import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

interface FormValue {
  op: 'replace';
  path: string;
  value: any;
}

@Injectable({
  providedIn: 'root',
})
export class HttpHelperService {
  createPatchBody(formGroup: UntypedFormGroup): FormValue[] {
    const bodyArray: FormValue[] = [];

    for (const controlName in formGroup.value) {
      if (formGroup.controls[controlName].dirty) {
        bodyArray.push({
          op: 'replace',
          path: `/${controlName}`,
          value: formGroup.value[controlName],
        });
      }
    }

    return bodyArray;
  }

  createInsertBody(formGroup: UntypedFormGroup): { [key: string]: any } {
    const body: { [key: string]: any } = {};

    for (const controlName in formGroup.value) {
      if (formGroup.controls[controlName].dirty) {
        body[controlName] = formGroup.value[controlName];
      }
    }

    return body;
  }

  createPutFormData(formGroup: UntypedFormGroup): FormData {
    const formData: FormData = new FormData();

    for (const controlName in formGroup.value) {
      if (formGroup.value[controlName]) {
        if (!(formGroup.controls[controlName] as UntypedFormGroup).controls) {
          formData.append(controlName, formGroup.value[controlName]);
        } else {
          for (const subControlName in formGroup.controls[controlName].value) {
            if (formGroup.controls[controlName].value[subControlName]) {
              formData.append(
                `${controlName}[${subControlName}]`,
                formGroup.controls[controlName].value[subControlName]
              );
            }
          }
        }
      }
    }

    return formData;
  }
}
